import React, { useEffect } from 'react';
import { P125MyProfilePage as P125MyProfilePageType } from '~/lib/data-contract';
import { MaxWidth } from '~/shared/components/MaxWidth';
import ProfileLayout from '~/features/my-profile/components/ProfileLayout/ProfileLayout';
import useCustomer from '~/features/commerce-api/hooks/useCustomer';
import { useRouter } from 'next/router';
import { ProfileProvider } from '../context/ProfileContext';
import styles from './P125MyProfilePage.module.scss';

type P125MyProfilePageProps = P125MyProfilePageType;

export const P125MyProfilePage = (props: P125MyProfilePageProps) => {
    const customer = useCustomer();
    const { replace } = useRouter();

    useEffect(() => {
        if (customer.isInitialized && customer.isGuest) {
            replace('/');
        }
    }, [customer, replace]);

    return (
        <ProfileProvider pageProps={props}>
            <MaxWidth>
                <div className={styles.profileContainer}>
                    <ProfileLayout />
                </div>
            </MaxWidth>
        </ProfileProvider>
    );
};

export default P125MyProfilePage;
